// @ts-nocheck

import { css, StyleSheet } from 'aphrodite/no-important'
import { get } from 'lodash'
import { FormFieldLayout, FormInput } from '../../generic'

export default function NumberField({
  className,
  errors,
  formFieldStyle,
  formKey,
  inputType,
  onChange,
  placeholder,
  positiveValuesOnly,
  minValue,
  readOnly,
  style,
  values,
  acceptZero = true,
  max,
  ...props
}) {
  // checks for preferredName field, which conditionally renders text
  const value = get(values, formKey)
  const error = get(errors, formKey)

  const handleChange = (e) => {
    const v = e.target.value

    if (positiveValuesOnly) {
      if (v < 0) return null
      if (max && v > max) return null
      if (!acceptZero && !(+v > 0)) return null
    }

    onChange({ key: formKey, value: v })
  }

  const handleOnBlur = (e) => {
    const v = e.target.value
    if (v !== '' && minValue != null && +v < minValue) {
      onChange({ key: formKey, value: minValue })
    }
  }

  if (readOnly) return <ReadOnly value={value} />

  return (
    <FormFieldLayout hasErrors={!!error} style={formFieldStyle} {...props}>
      <div style={{ maxWidth: 120, ...style }}>
        <FormInput
          className={css(classes.input)}
          error={error}
          onChange={handleChange}
          placeholder={placeholder}
          value={value}
          type="number"
          min={minValue}
          onBlur={handleOnBlur}
          data-testid={props['data-testid']}
        />
      </div>
    </FormFieldLayout>
  )
}

const ReadOnly = ({ value }) => (
  <div className={css(classes.readOnly)}>{value}</div>
)

const classes = StyleSheet.create({
  readOnly: {
    padding: '12px 12px 12px 0px'
  },
  input: {
    textAlign: 'right'
  }
})
